import { createOperation } from "../operations";

export const fetchingMenuDataAdUnitOperation = createOperation<void>("MENUDATA/FETCH_AD_UNITS");
export const fetchingMenuDataUpdateOperation = createOperation<void>("MENUDATA/FETCH_LATEST_UPDATE");
export const fetchingBackgroundImageOperation = createOperation<void>("MENUDATA/FETCH_BACKGROUND_IMAGE");
